import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import keycloak from './keycloak';

keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256', checkLoginIframe: false }).then((authenticated) => {
  if (!authenticated) return;

  const root = ReactDOM.createRoot(document.getElementById('root'));

  if (!keycloak.hasResourceRole('accountant', 'fair-finance-app')) {
    root.render(
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif', color: '#333' }}>
        <h2>Kein Zugriff</h2>
        <p>Ihr Konto hat keine Berechtigung für Fair Finance.</p>
        <p style={{ color: '#888', fontSize: 14 }}>Bitte wenden Sie sich an den Administrator, um die Rolle <strong>accountant</strong> zu erhalten.</p>
        <button onClick={() => keycloak.logout()} style={{ marginTop: 24, padding: '8px 20px', cursor: 'pointer' }}>Abmelden</button>
      </div>
    );
    return;
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
});
